import axios from 'src/utils/axios';
import { AxiosResponse } from 'axios';

export default class CertificationService {
  public static createCertificationCategoryAndStatuses = async (
    payload
  ): Promise<AxiosResponse> => {
    return axios.post(
      `/certification/certification_config/create_new_category_and_statuses/`,
      payload
    );
  };

  public static deleteCertificationCategory = async (
    categoryID
  ): Promise<AxiosResponse> => {
    return axios.delete(`/certification/category/${categoryID}`);
  };

  public static updateCertificationCategory = async (
    id: number,
    partialPayload: Record<string, unknown>
  ): Promise<AxiosResponse> => {
    return axios.patch(`/certification/category/${id}/`, partialPayload);
  };

  public static createCategoryStatus = async (
    payload
  ): Promise<AxiosResponse> => {
    return axios.post(`/certification/status/`, payload);
  };

  public static updateCategoryStatus = async (
    payload
  ): Promise<AxiosResponse> => {
    return axios.patch(`/certification/status/bulk_update/`, payload);
  };

  public static updateCertification = async (
    certification_id,
    payload,
    queryParams = null
  ): Promise<AxiosResponse> => {
    let url = `/certification/certification/${certification_id}/`;
    if (queryParams) {
      url += `?${queryParams}`;
    }
    return axios.patch(url, payload);
  };

  public static createNewCertification = async (
    certificationsPayload
  ): Promise<AxiosResponse> => {
    return axios.post('invite_to_new_program/', certificationsPayload);
  };

  public static updateCertCategoryStatus = async (
    payload,
    params = null
  ): Promise<AxiosResponse> => {
    let url = 'certification/status_step/';
    if (params) {
      url += `?${params}`;
    }
    return axios.post(url, payload);
  };

  public static fetchCategoriesInCerts = async (
    ids: number[],
    params: string
  ): Promise<AxiosResponse> => {
    return axios.get(`/certification/category/?id__in=${ids}&${params}`);
  };

  public static getRecertNotices = async (
    propertyId: number,
    timeframe?: string
  ): Promise<AxiosResponse> => {
    const timeframeParam = timeframe ? `&timeframe=${timeframe}` : '';
    return axios.get(
      `/recert-notices/?property_id=${propertyId}${timeframeParam}`
    );
  };

  public static getRecertNoticesNeedsCreation = async (
    propertyId: number
  ): Promise<AxiosResponse> => {
    return axios.get(
      `/recert-notices/?property_id=${propertyId}&needs_creation=true`
    );
  };

  public static getRecertNoticeConfigs = async (
    propertyId: number
  ): Promise<AxiosResponse> => {
    return axios.get(`/recert-notices/configs/?property_id=${propertyId}`);
  };

  public static createRecertification = async (payload: {
    tracking_id: number;
    certification_config_id: number;
    force?: boolean;
  }): Promise<AxiosResponse> => {
    return axios.post(`/recert-notices/create/`, payload);
  };

  public static sendRecertNotice = async (payload: {
    tracking_id: number;
    days: number;
  }): Promise<AxiosResponse> => {
    return axios.post(`/recert-notices/send-notice/`, payload);
  };

  public static previewRecertNotice = async (payload: {
    tracking_id: number;
    days: number;
  }): Promise<AxiosResponse<{ body: string; subject?: string }>> => {
    return axios.post(`/recert-notices/preview-notice/`, payload);
  };

  public static downloadRecertNotice = async (payload: {
    tracking_id: number;
    days: number;
  }): Promise<AxiosResponse<Blob>> => {
    return axios.post(`/recert-notices/download-notice/`, payload, {
      responseType: 'blob',
    });
  };

  public static dismissRecertNotice = async (
    trackingId: number,
    payload: { justification: string }
  ): Promise<AxiosResponse> => {
    return axios.post(`/recert-notices/${trackingId}/dismiss/`, payload);
  };
}
